module.exports = __webpack_public_path__ + "img/carne.837d4f8b.svg";